import CarouselSection, {
  CarouselSectionProps,
} from './carousel-section/CarouselSection'
import ImageSection, { ImageSectionProps } from './image-section/ImageSection'
import QuoteSection, { QuoteSectionProps } from './quote-section/QuoteSection'
import React, {
  Fragment,
  FunctionComponent,
  ReactElement,
  useCallback,
} from 'react'
import TalksSection, { TalksSectionProps } from './talks-section/TalksSection'
import TextSection, { TextSectionProps } from './text-section/TextSection'
import TextWithImageSection, {
  TextWithImageSectionProps,
} from './text-with-image-section/TextWithImageSection'
import VideoSection, { VideoSectionProps } from './video-section/VideoSection'

export enum SectionType {
  CAROUSEL = 'Carousel',
  IMAGE = 'Image',
  QUOTE = 'Quote',
  TALKS = 'Talks',
  TEXT = 'Text',
  TEXT_WITH_IMAGE = 'TextWithImage',
  VIDEO = 'Video',
}

export interface SectionProps {
  type: SectionType
}

interface SectionsProps {
  sections: SectionProps[]
}

const Sections: FunctionComponent<SectionsProps> = ({ sections }) => {
  /**
   * Return the section based on given type
   */
  const getSection = useCallback(
    (section: SectionProps, index: number): ReactElement | null => {
      switch (section.type) {
        case SectionType.CAROUSEL:
          return (
            <CarouselSection
              {...(section as CarouselSectionProps)}
              key={`section-${index}`}
            />
          )

        case SectionType.IMAGE:
          return (
            <ImageSection
              {...(section as ImageSectionProps)}
              key={`section-${index}`}
            />
          )

        case SectionType.QUOTE:
          return (
            <QuoteSection
              {...(section as QuoteSectionProps)}
              key={`section-${index}`}
            />
          )

        case SectionType.TEXT:
          return (
            <TextSection
              {...(section as TextSectionProps)}
              alignment={(section as TextSectionProps).alignment || undefined}
              key={`section-${index}`}
            />
          )

        case SectionType.TEXT_WITH_IMAGE:
          return (
            <TextWithImageSection
              {...(section as TextWithImageSectionProps)}
              key={`section-${index}`}
            />
          )

        case SectionType.VIDEO:
          return (
            <VideoSection
              {...(section as VideoSectionProps)}
              key={`section-${index}`}
            />
          )

        case SectionType.TALKS:
          return (
            <TalksSection
              {...(section as TalksSectionProps)}
              key={`section-${index}`}
            />
          )

        default:
          return null
      }
    },
    [],
  )

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <Fragment>
      {sections.map((section, index) => getSection(section, index))}
    </Fragment>
  )
}

export default Sections
